import { createApi } from '@reduxjs/toolkit/query/react';
import { authorizedFetch, noAuthorizedFetch } from '../../utils/api';

const authorizedBaseQuery = async (args, api, extraOptions) => {
  const { url, method = 'GET', body, params, responseHandle, isPublic } = typeof args === 'string' ? { url: args } : args;
  
  const baseUrl = import.meta.env.VITE_GENERAL_BASE_URL || '';
  let fullUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;
  // ... (params logic)
  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, value);
      }
    });
    const queryString = searchParams.toString();
    if (queryString) {
      fullUrl += (fullUrl.includes('?') ? '&' : '?') + queryString;
    }
  }

  try {
    const doFetch = isPublic ? noAuthorizedFetch : authorizedFetch;
    const result = await doFetch(fullUrl, {
      method,
      body,
      ...extraOptions
    });
    
    // Nếu có hàm responseHandle, cho phép tiền xử lý response
    if (responseHandle) {
      return { data: responseHandle(result) };
    }
    
    return { data: result };
  } catch (err) {
    // Nếu có hàm responseHandle, cho phép xử lý lỗi (ví dụ: trả về mock data)
    if (responseHandle) {
      try {
        const handledResult = responseHandle(err);
        if (handledResult) return { data: handledResult };
      } catch (e) {
        // Nếu responseHandle cũng quăng lỗi, tiếp tục xử lý lỗi mặc định
      }
    }

    return {
      error: {
        status: err.status || 500,
        data: err.response || err.message,
      },
    };
  }
};

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: authorizedBaseQuery,
  tagTypes: ['PortfolioStats'],
  endpoints: () => ({}),
});
